export default __webpack_public_path__ + "static/media/APACHE RR 310_4.a782cc36.webp";